import { Info } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import React from "react";

interface DescriptionTooltipProps {
  title?: string;
}

const DecriptionTooltip: React.FC<DescriptionTooltipProps> = ({ title }) => {
  if (!title) {
    return null;
  }
  return (
    <Tooltip title={title}>
      <Info />
    </Tooltip>
  );
};
export default DecriptionTooltip;
